'use client';

import {
  HomeLandingSections,
  HomeStoriesSection,
  HomeCommunitySection,
  HomeVoicesSection,
  HomeAboutSection,
  CommunityMatrimonyServices,
} from '@/components/homePageSections';

import { useState } from 'react';
import Header from '@/components/Header';
import HomeHeroSection from '@/components/HomeHeroSection';

const communityServices: { label: string; href?: string }[] = [
  { label: "Vanjari Caste" },
  { label: "Vanjari Matrimony" },
  { label: "Vanjari Caste category" },
  { label: "Vanjari Caste category in Maharashtra" },
  { label: "Vanjari Samaj" },
  { label: "Vanjari Brides" },
  { label: "Vanjari caste population in Maharashtra" },
  { label: "Vanjari matrimony login" },
  { label: "Vanjari caste SC or OBC" },
  { label: "Vanjari population in Maharashtra" },
  { label: "Vanjari matrimony WhatsApp group link" },
  { label: "Lad Vanjari Mangal Karyalaya Jalgaon photos" },
  { label: "Vanjari Matrimony Girl" },
  { label: "Vanjari caste OBC" },
  { label: "Lad Vanjari Mangal Karyalaya Jalgaon" },
  { label: "Vanjari Vadhu Var Suchak Kendra Ahmednagar" },
  { label: "Vanjari Vadhu Var Suchak" },
  { label: "Vanjari Vadhu Var WhatsApp Group" },
  { label: "Vanjari Vadhu Var Suchak Kendra Aurangabad" },
  { label: "Vanjari Vadhu Var Mahiti" },
  { label: "Vanjari Vadhu Var Suchak Kendra Pune" },
  { label: "Vanjari Vadhu Var Suchak Kendra Nashik" },
  { label: "Vanjari Vadhu Var Suchak Mandal" },
  { label: "Vanjari Vadhu Var Mandal" },
  { label: "Vanjari Vadhu Var WhatsApp group link" },
  { label: "Vanjari Grooms" },
  { label: "Vanjari Grooms Pune" },
  { label: "Vanjari Grooms Mumbai" },
  { label: "Vanjari brides Pune" },
  { label: "Vanjari brides Aurangabad" },
  { label: "Vanjari brides Beed" },
  { label: "Jeevansathi Vanjari Brides" },
  { label: "Vanjari brides Mumbai" },
  { label: "Vanjari brides Nashik" },
];

export default function VanjariMatrimony() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  return (
    <div className="bg-white">
      {/* Transparent Header */}
      <Header variant="transparent" />

      <HomeHeroSection
        title="वंजारी समाजातील वधू वरांसाठी"
        subtitle="महाराष्ट्रातील अग्रणी विवाहसंस्था"
        trackingSource="vanjari_matrimony"
      />

      <HomeLandingSections />

      <HomeStoriesSection />

      <HomeCommunitySection />

      <HomeVoicesSection />

      <HomeAboutSection />

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
            Frequently Asked Questions
          </h2>
          <div className="max-w-4xl mx-auto">
            <div className="space-y-4">
              {[
                {
                  question: "How to search the Vanjari matrimony grooms?",
                  answer: "To search Vanjari grooms, first register free on MarathiVadhuVarSuchak.com Marathi matrimonial site."
                },
                {
                  question: "How to join Vanjari matrimony WhatsApp group link?",
                  answer: "Because of strict privacy policy, MarathiVadhuVarSuchak.com Marathi matrimony does not have any WhatsApp group link to join."
                },
                {
                  question: "What is the Vanjari Matrimony login process?",
                  answer: "First register through MarathiVadhuVarSuchak.com Marathi site. After approval Vanjari grooms and brides can login online."
                },
                {
                  question: "How to search Vanjari matrimony photos?",
                  answer: "To search Vanjari matrimony photos with full profile first register through MarathiVadhuVarSuchak.com Marathi matrimonial site."
                },
                {
                  question: "Which is the best Vanjari matrimony Mumbai?",
                  answer: "MarathiVadhuVarSuchak.com Marathi matrimony is the best Vanjari matrimony in Mumbai for Vanjari Samaj Vadhu Var."
                },
                {
                  question: "How to search Vanjari Matrimony girl profiles online?",
                  answer: "Visit MarathiVadhuVarSuchak.com Marathi matrimony to register free. After approval you can search Vanjari girl profiles online."
                },
                {
                  question: "How to search Vanjari Matrimony Pune Grooms online?",
                  answer: "To search Vanjari Samaj Pune Grooms online first register free on MarathiVadhuVarSuchak.com Marathi matrimony site."
                },
                {
                  question: "How to search Vanjari matrimony contact number?",
                  answer: "To search Vanjari matrimony grooms and brides contact number first register free through MarathiVadhuVarSuchak.com"
                },
                {
                  question: "How to join Vanjari Vadhu Var Suchak WhatsApp number?",
                  answer: "No! Due to privacy policy, MarathiVadhuVarSuchak.com Marathi matrimony does not have any WhatsApp number to join."
                },
                {
                  question: "How to join Vanjari Vadhu Var Suchak WhatsApp group link?",
                  answer: "Unfortunately! MarathiVadhuVarSuchak.com Marathi matrimony does not any WhatsApp group link to join because of privacy policy."
                },
                {
                  question: "How to search Vanjari Vadhu Var Suchak photos online?",
                  answer: "First register free on MarathiVadhuVarSuchak.com Marathi matrimony portal. After verification and approval you can search Vanjari Vadhu Var Suchak profiles with photo."
                },
                {
                  question: "How to get Vanjari Vadhu Var Suchak contact number?",
                  answer: "Visit MarathiVadhuVarSuchak.com Marathi matrimony site to get Vanjari Vadhu Var Suchak contact number online."
                },
                {
                  question: "How to search Vanjari brides profile online?",
                  answer: "To search Vanjari brides profile online you have to register through MarathiVadhuVarSuchak.com Marathi matrimonial site."
                },
                {
                  question: "How to get Vanjari Vadhu var suchak phone number online?",
                  answer: "To get Vanjari Vadhu var suchak phone number online visit MarathiVadhuVarSuchak.com Marathi matrimonial portal."
                },
                {
                  question: "Which is the best Vanjari Vadhu Var Suchak Kendra Nashik?",
                  answer: "Vanjari Vadhu Var staying at Nashik can register free through MarathiVadhuVarSuchak.com to search profiles from Nashik region."
                },
                {
                  question: "Which is the best Vanjari Vadhu Var Suchak Kendra Pune?",
                  answer: "MarathiVadhuVarSuchak.com Marathi matrimony is the best Vadhu Var Suchak Kendra for Pune based grooms and brides from Pune."
                },
                {
                  question: "How to search Vanjari grooms list online?",
                  answer: "First register free on MarathiVadhuVarSuchak.com Marathi matrimony. After approval you can search for Vanjari grooms list online."
                },
                {
                  question: "How to search the Vanjari grooms photos online?",
                  answer: "To search the Vanjari grooms photos online you Vanjari Samaj brides have to register free on MarathiVadhuVarSuchak.com Marathi matrimony."
                },
                {
                  question: "How to search Vanjari grooms contact number online?",
                  answer: "To search Vanjari grooms contact number online Vanjari Samaj brides have to register free through MarathiVadhuVarSuchak.com Marathi matrimonial site."
                },
                {
                  question: "How to search Vanjari officer Grooms in Mumbai?",
                  answer: "To search Vanjari officer Grooms in Mumbai Vanjari Samaj brides have to register free on MarathiVadhuVarSuchak.com Marathi matrimony."
                },
                {
                  question: "How to search Vanjari Matrimony Brides online?",
                  answer: "To search Vanjari Matrimony Brides online register free on MarathiVadhuVarSuchak.com."
                },
                {
                  question: "How to search Vanjari brides photos with profile?",
                  answer: "Register free on MarathiVadhuVarSuchak.com and after approval you can search Vanjari brides photos with profile."
                },
                {
                  question: "How to join Vanjari brides WhatsApp group online?",
                  answer: "No! Because of strict privacy policy, we do not any WhatsApp group to join online."
                },
                {
                  question: "How to search Vanjari brides list online?",
                  answer: "To search Vanjari brides list online register free on MarathiVadhuVarSuchak.com Marathi matrimony."
                },
                {
                  question: "How to join Vanjari brides WhatsApp group link?",
                  answer: "No! We do not have any WhatsApp group link to join because of privacy policy."
                },
                {
                  question: "How to search Jeevansathi Vanjari Brides online?",
                  answer: "Visit MarathiVadhuVarSuchak.com to register free. After verification and approval you can search Vanjari brides online."
                },
                {
                  question: "How to join Vanjari matrimony WhatsApp group link?",
                  answer: "No! Due to privacy policy, we do not have any WhatsApp group link to join."
                },
                {
                  question: "How to search Vanjari brides Pune?",
                  answer: "Register free on MarathiVadhuVarSuchak.com Marathi matrimony. Then you can search Vanjari brides from Pune."
                },
                {
                  question: "How to search Vanjari Vadhu photos with profile?",
                  answer: "First register through MarathiVadhuVarSuchak.com site. After verification and approval you can search Vanjari Vadhu photos with profile online."
                },
                {
                  question: "How to join Vanjari Vadhu WhatsApp group?",
                  answer: "We follow strict privacy policy, so do not have any WhatsApp group to join."
                }
              ].map((faq, index) => (
                <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                  <button
                    onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                    className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                  >
                    <h3 className="text-lg font-semibold text-gray-900">
                      {faq.question}
                    </h3>
                    <svg
                      className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${
                        openFAQ === index ? 'rotate-180' : ''
                      }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <div
                    className={`px-6 transition-all duration-300 ease-in-out ${
                      openFAQ === index ? 'pb-4 max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'
                    }`}
                  >
                    <div className="text-gray-600 leading-relaxed py-3">
                      <p className="mb-3">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CommunityMatrimonyServices
        title="Vanjari Matrimony for Marathi Communities"
        items={communityServices}
      />

    </div>
  );
}
